// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5L11.4806 2.5L13.4806 5H23V7H12.5194L10.5194 4.5L1 4.5L1 2.5ZM1 6.5L9.48063 6.5L11.4806 9H23V21H1L1 6.5Z"}}]};

const FolderOpenFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-open-filled',
    ref,
    icon: element,
  },
));

FolderOpenFilledIcon.displayName = 'FolderOpenFilledIcon';

export default FolderOpenFilledIcon;
